class SaInnovationTableOfContents extends HTMLElement {
  connectedCallback() {
    this.progressValue = this.querySelector('[data-sa-ih-progress-value]');
    this.progressBar = this.querySelector('[role="progressbar"]');
    this.sectionRoot = this.closest('.sa-innovation-highlights');

    if (!this.progressValue || !this.progressBar || !this.sectionRoot) return;

    this.abortController = new AbortController();
    const listenerOptions = { passive: true, signal: this.abortController.signal };

    window.addEventListener('scroll', this.requestUpdate, listenerOptions);
    window.addEventListener('resize', this.requestUpdate, listenerOptions);
    this.requestUpdate();
  }

  disconnectedCallback() {
    this.abortController?.abort();

    if (this.animationFrame) {
      window.cancelAnimationFrame(this.animationFrame);
    }
  }

  requestUpdate = () => {
    if (this.animationFrame) return;

    this.animationFrame = window.requestAnimationFrame(() => {
      this.animationFrame = null;
      this.updateProgress();
    });
  };

  updateProgress() {
    const sectionBounds = this.sectionRoot.getBoundingClientRect();
    const sectionTop = window.scrollY + sectionBounds.top;
    const headerHeight = Number.parseFloat(
      window.getComputedStyle(document.body).getPropertyValue('--header-height')
    ) || 0;
    const progressStart = sectionTop - headerHeight;
    const progressEnd = sectionTop + this.sectionRoot.offsetHeight - window.innerHeight;
    const progressRange = Math.max(progressEnd - progressStart, 1);
    const progress = Math.min(Math.max((window.scrollY - progressStart) / progressRange, 0), 1);
    const percentage = Math.round(progress * 100);

    this.style.setProperty('--sa-ih-progress', `${percentage}%`);
    this.progressBar.setAttribute('aria-valuenow', percentage.toString());
    this.progressValue.textContent = `${percentage}%`;
  }
}

if (!customElements.get('sa-innovation-table-of-contents')) {
  customElements.define('sa-innovation-table-of-contents', SaInnovationTableOfContents);
}
